import { useIntl, getLocale } from 'umi';
import { LANGUAGE_EN, LANGUAGE_CN } from '@intelligence/_config/config';

/**
 * 对umi 翻译插件的formatMessage方法 增加异常处理
 * 返回的formatMessage方法使用，与umi useIntl返回的formatMessage方法使用一致
 * @returns 与umi的useIntl方法返回一致，增加了isEN、isCN两个变量
 * umi formatMessage方法在翻译时，若指定的id，在locale配置表中不存在，就会报错，导致白屏，所以在处理翻译的id是程序动态组装的场景下，可以使用这个，避免id不存在时报错
 */
export default function useIntlExtend() {
  const originalIntl = useIntl();
  const locale = getLocale();
  const originalFormatMessage = originalIntl?.formatMessage as unknown as IFormatMessage;
  // 获取 messages 对象，用于检查翻译 key 是否存在
  const messages = (originalIntl as any)?.messages || {};

  const extendFormatMessage: IFormatMessage = (...args) => {
    const descriptor = args?.[0];
    const messageId = descriptor?.id as string;
    
    // 如果 messageId 不存在，直接返回空字符串
    if (!messageId) {
      return '';
    }
    
    // 检查 messages 对象中是否存在该 key，如果不存在则直接返回 key 本身，避免调用 formatMessage 产生警告
    if (!Object.prototype.hasOwnProperty.call(messages, messageId)) {
      return messageId;
    }
    
    // 如果 key 存在，正常调用 formatMessage
    let result = '';
    try {
      result = originalFormatMessage?.(...args);
    } catch (exception) {
      // console.error(exception);
      result = messageId;
    }
    return result;
  };

  return {
    ...originalIntl,
    isEN: locale === LANGUAGE_EN,
    isCN: locale === LANGUAGE_CN,
    locale,
    formatMessage: extendFormatMessage,
  };
}
